import { gql } from '@apollo/client/core';

export const FETCH_FC_SHARED_JOBS = gql`
  query SharedJobDetails($jobId: UUID!) {
    jobDetails(jobId: $jobId) {
      jobId
      title
      sharedJobEmails
    }
  }
`;

export default {
  FETCH_FC_SHARED_JOBS,
};
